import { Route, Routes } from 'react-router-dom';
import { hasAccessRight } from '../../utils/Functions';
import { AdminAclEnum } from '../../enum/AdminAclEnum';
import ReportsList from './components/ReportsList';
import { ReportsForm } from './components/ReportsForm';
import { ReportingOverview } from './components/ReportingOverview';

export function ReportingRoutes() {
    return (
        <Routes>
            {hasAccessRight(AdminAclEnum.REPORTING) && <Route path="overview" element={<ReportingOverview />} />}
            {hasAccessRight(AdminAclEnum.REPORT_ITEMS) && (
                <>
                    <Route path="approved" element={<ReportsList isRejected={false} />} />
                    <Route path="edit/:reportId" element={<ReportsForm />} />
                    <Route path="rejected" element={<ReportsList isRejected={true} sortBy={'verifyDate'} />} />
                </>
            )}
        </Routes>
    );
}
